jQuery.noConflict();

jQuery(document).ready(function( $ ) {
    /*
     * MENU
     */
    $('#mainnavigation a[href*="News"]').attr('target', '_blank');


    /*
     * MOBILE MENU
     */
    $('.navbar').on('click', '.navbar-burger', function(event) {
      event.preventDefault();

      $navbarBurger = $(this);
      var target = $navbarBurger.data('target');

      // Toggle the class on both the "navbar-burger" and the "navbar-menu"
      $navbarBurger.toggleClass('is-active');
      $('#'+target).toggleClass('is-active');
    });


    /*
     * ACTOR SUBNAV
     */
    var actors = apiACTORS || [];
    var navActor = $('#mainnavigation a[href="'+slugACTORS+'"]').parent();

    navActor.addClass('has-dropdown is-hoverable').append('<ul class="navbar-dropdown" />')

    for(var a in actors) {
      if (actors[a].id != null) {
        var encoded = encodeURIComponent(actors[a].name);
        var slug = encoded.replace(new RegExp('%20', 'g'), "+") + '/';

        navActor.find('ul').append('<li class="navbar-item"><a href="'+slugACTORS+slug+'">'+actors[a].name+'</a></li>')
      }
    }


    /*
     * ACTOR INFO
     */
    $('.actor-info').on('click', '.tabs a', function(event) {
      event.preventDefault();
      
      var target = $(this).attr('href');

      window.location = target;

      showInfoTab(target);
    });

    // Show active tab on load
    if(window.location.hash) {
      showInfoTab(window.location.hash);
    }

    function showInfoTab (tab) {
      tab = typeof tab !== 'undefined' ? tab : '#info';
      
      if ( $(tab).length > 0 ) {
        $('.tab').addClass('is-hidden');
        $(tab).removeClass('is-hidden');

        $('.tabs a').each(function(index, el) {
          $(el).removeClass('is-hidden');
        });
        $('.tabs a[href="'+ tab +'"]').addClass('is-hidden');
      }
    };

    $('.actor-slider').slick({
      fade: true,
      cssEase: 'linear',
      adaptiveHeight : true,
      initialSlide : parseInt(window.location.hash.substr(1)) || 0
    });
    
    $(window).on('resize orientationchange', function() {
      $('.actor-slider').slick('resize');
    });

    $('.actor-info').on('click', 'a.show-actor-vita', function(event) {
      event.preventDefault();
      
      var target = $(this).attr('href');

      $(target).addClass('is-active');
      $(this).hide()
    });


    /*
     * ACTOR FOTO
     */
     $('.actor-photos').justifiedGallery({
      rowHeight: 260,
      margins: 2,
      captions: false
     });
});
